export * from './usePersonalizedRecommendationCardContentfulData';
